export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-building-4-line"></i>
              <span className="whitespace-nowrap">品牌介绍</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">关于白云视频</h2>
            <div className="mt-5 space-y-3 text-sm text-foreground-600 leading-relaxed">
              <p>
                白云视频诞生于移动互联网时代，致力于为广大影视爱好者提供高清流畅的手机看片体验。作为苹果视频、榴莲视频与桃子视频的同类型平台，白云视频以「看视频app」为核心定位，聚合海量免费影视资源，打造一站式在线视频平台。
              </p>
              <p>
                平台覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日实时更新最新资源。无论是热门院线大片、经典剧集还是小众佳作，白云视频都力求呈现高清画质与稳定流畅的播放体验，让手机视频播放真正摆脱缓冲与卡顿的烦恼。
              </p>
              <p>
                我们坚持免费观影理念，用户无需付费即可畅享全部内容。白云视频团队持续优化播放技术与推荐算法，致力于成为最懂你的视频播放平台，让每一次打开都是一场愉悦的观影之旅。
              </p>
            </div>
            <div className="mt-6 grid grid-cols-3 gap-4 text-center">
              <div className="p-3 rounded-lg bg-primary-50/60">
                <div className="text-lg font-bold text-primary-500">3年+</div>
                <div className="text-xs text-foreground-500 mt-0.5">稳定运营</div>
              </div>
              <div className="p-3 rounded-lg bg-accent-50/60">
                <div className="text-lg font-bold text-accent-500">99.9%</div>
                <div className="text-xs text-foreground-500 mt-0.5">播放成功率</div>
              </div>
              <div className="p-3 rounded-lg bg-secondary-100/60">
                <div className="text-lg font-bold text-secondary-600">全品类</div>
                <div className="text-xs text-foreground-500 mt-0.5">内容覆盖</div>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-md h-[300px] md:h-[360px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20entertainment%20streaming%20platform%20concept%20with%20floating%20movie%20poster%20cards%20in%20warm%20coral%20and%20amber%20gradient%20tones%2C%20soft%20abstract%20geometric%20shapes%2C%20cinematic%20atmosphere%2C%20clean%20composition%20with%20depth%20of%20field%2C%20professional%20studio%20lighting%2C%20high%20quality%20editorial%20photography%20style&width=800&height=720&seq=about-platform-visual&orientation=landscape"
                alt="白云视频平台介绍"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}